import { defineMessages } from 'react-intl'


export default defineMessages({
  ariaLabel: {
    defaultMessage: 'Cookie Consent Prompt',
    id: 'consent-prompt.aria-label',
  },
})
